exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket-bottom-div[data-v-48c987ba] {\n  position:fixed;\n  bottom:0;\n  width: 100vw;\n  text-align: center;\n  height:30px;\n  color:#c7c392;\n  margin: 0 auto;\n  -webkit-filter: brightness(70%) drop-shadow(1px 1px 10px #707070);\n          filter: brightness(70%) drop-shadow(1px 1px 10px #707070);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48c987ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketBottom.vue
// module id = 763
// module chunks = 75